import { GetEventListRequestType } from '../../../../../types/query/event/list';
import EventApiV2 from '../../../../../lib/api/event/EventApiV2';
import { EventItemV2 } from '../../../../../types/event';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const eventListFetcher = async (option: GetEventListRequestType) => {
  const defaultResult = {
    totalCount: 0,
    events: [],
  };

  const result = checkValidId([option.id]) ? await EventApiV2.getEventList(option) : defaultResult;

  return {
    totalCount: result.totalCount,
    list: result.events.map((event) => new EventItemV2(event)),
  };
};
